const isImage = ['gif', 'jpg', 'jpeg', 'png', 'tiff', 'bmp', 'heic', 'svg', 'webp'];
const isVideo = ['mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'mp4', 'mov', 'wmv', 'flv', 'avi', 'hevc'];

export const getAttachmentType = att => {
  const attachment = att?.attributes?.content;
  const extension =
    attachment &&
    attachment
      .split(/[#?]/)[0]
      .split('.')
      .pop()
      .trim()
      .toLowerCase();

  return isImage.includes(extension)
    ? { type: 'image', link: attachment }
    : isVideo.includes(extension)
    ? { type: 'video', link: attachment }
    : attachment;
};
